<template>
  <!-- 教育经历 -->
  <!-- ApplyForAJob和IndividualEdit都等于1时 正常显示求职意向 若有一条不等于1说明用户点击了添加或单条编辑 这时就要展示编辑栏 -->
  <div :class="IndividualEdit == 1 ? 'normal' : 'editor'">
    <div class="Title-Add-box">
      <div class="Title-Add" @click="handelClickEDITOR"></div>
      <p class="Title-p" @click="handelClickEDITOR">添加教育经历</p>
    </div>
    <!-- 正常展示数据 -->
    <div v-if="IndividualEdit == 1" class="NormalDisplay">
      <!-- 没有数据显示待添加 -->
      <div class="None firm-clickable" v-if="data.length == 0" @click="handelClickEDITOR">
        待添加
      </div>
      <div
        class="normal-show"
        v-else
        v-for="(item, index) in data"
        :key="index"
      >
        <div class="top-threeRows">
          <p>{{ item.schoolName }}</p>
          <p>{{ item.xlName }}</p>
          <p>{{ item.subjectName }}</p>
          <p>{{ item.startTime }} 至 {{ item.endTime }}</p>
          <div class="icon firm-clickable" @click="handelClickSingle(item, index)"></div>
        </div>
      </div>
    </div>
    <!-- 显示编辑栏 -->
    <div v-if="IndividualEdit == 2" class="StartEditing">
      <div class="EDITOR-top">
        <div class="EDITOR-required">
          <div class="required-title-p">
            <p v-for="(item, index) in titleArr" :key="index">
              <span v-if="item.Required == '1'" style="color: red">*</span>
              {{ item.name }}：
            </p>
          </div>
          <div class="required-ipt">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <!-- 学校名称 -->
              <div class="input-place">
                <el-form-item prop="schoolName">
                  <el-autocomplete
                    class="inline-input"
                    v-model="ruleForm.schoolName"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入"
                    :trigger-on-focus="false"
                    @select="handleSelect"
                  ></el-autocomplete>
                </el-form-item>
              </div>
              <!-- 学历 -->

              <div class="input-place learn">
                <p
                  v-for="(item, index) in learnArr"
                  :key="index"
                  class="Select-All"
                  :class="xlCode == item.id ? 'Select-p' : 'notSelect-p'"
                  @click="handelLearn(item)"
                >
                  {{ item.name }}
                </p>
              </div>

              <!-- 是否全日制 -->
              <div class="input-place">
                <p
                  v-for="(item, index) in fullTimeArr"
                  :key="index"
                  class="Select-All"
                  :class="fullTime == item.id ? 'Select-p' : 'notSelect-p'"
                  @click="handelFullTime(item)"
                >
                  {{ item.name }}
                </p>
              </div>
              <!-- 专业 -->
              <div class="input-place">
                <el-form-item prop="subjectName">
                  <el-select
                    v-model="ruleForm.subjectName"
                    filterable
                    remote
                    placeholder="请输入专业名称"
                    :remote-method="Profession"
                    :loading="loading"
                    @change="pestChange"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>

              <!-- 在校日期 -->
              <div class="input-place">
                <el-form-item prop="startTime" style="margin-right: 10px">
                  <el-date-picker
                    v-model="ruleForm.startTime"
                    type="month"
                    placeholder="请选择"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="startTimePickerOptions"
                  >
                  </el-date-picker>
                </el-form-item>
                <!-- <el-date-picker v-model="value1" type="date" placeholder="请选择">
              </el-date-picker> -->
                <p class="to-p">至</p>
                <el-form-item prop="endTime" style="margin-left: 10px">
                  <el-date-picker
                    v-model="ruleForm.endTime"
                    type="month"
                    placeholder="请选择"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="endTimePickerOptions"
                  >
                  </el-date-picker>
                </el-form-item>
                <!-- <el-date-picker v-model="value1" type="date" placeholder="请选择">
              </el-date-picker> -->
              </div>
              <!-- 证书 -->
              <div class="input-place">
                <el-input
                  v-model="ruleForm.certiNum"
                  placeholder="请输入证书编号"
                ></el-input>
              </div>
            </el-form>
          </div>
          <div class="required-dele">
            <div class="firm-clickable" @click="handelDele" v-if="ApplyForAJob != '1'"></div>
          </div>
        </div>
      </div>
      <!-- 编辑栏按钮 -->
      <div class="EDITOR-btm">
        <p class="Cancel" @click="handelUnEdit">取消</p>
        <p class="verify" @click="handelSubmitEdit('ruleForm')">确认</p>
      </div>
    </div>
  </div>
</template>

<script>
// 引入接口
import {
  postFindUniversityByName, // 搜索大学名称
  postFindSubjectByName, // 搜索专业
} from "../../../../../../assets/api/indexl";
import {
  addUserEducationExp, // 添加
  editUserEducationExp, //编辑
  deleteUserEducationExp, //删除
} from "../../../../../../assets/api/CenterJane";
// 封装的表单验证
import { vxRule } from "../../../../../../../untils/FormValidation/validate-form";
export default {
  // 接收父组件传递的数据
  props: {
    data: {},
  },
  data() {
    return {
      restaurants: [],
      IndividualEdit: 1, // 单条编辑
      titleArr: [
        { name: "学校名称", Required: "1" },
        { name: "学历", Required: "1" },
        { name: "是否全日制", Required: "1" },
        { name: "专业", Required: "1" },
        { name: "在校时间", Required: "1" },
        { name: "证书编号" },
      ], // 编辑栏 input框右侧标题

      learnArr: [
        { name: "初中及以下", id: "0" },
        { name: "中专/中技", id: "1" },
        { name: "高中", id: "2" },
        { name: "大专", id: "3" },
        { name: "本科", id: "4" },
        { name: "硕士", id: "5" },
        { name: "博士", id: "6" },
      ], // 学历选择

      fullTimeArr: [
        { name: "全日制", id: "0" },
        { name: "非全日制", id: "1" },
      ], //是否全日制
      xlCode: "0", // 学历
      fullTime: "0", //全日
      ruleForm: {
        schoolCode: "", // 学校code
        schoolName: "", // 学校名称
        xlCode: "0", //学历code
        xlName: "初中及以下", // 学历选择
        fullTime: "全日制", //是否全日制的选择
        subjectCode: "", // 专业code
        subjectName: "", //专业
        startTime: "", // 在校时间开
        endTime: "", // 在校时间结束
        certiNum: "", // 证书编号
      }, // v-mode
      endTimePickerOptions: {
        disabledDate: (time) => {
          // 如果还没选开始时间 → 不限制
          if (!this.ruleForm.startTime) return false;

          // 已经选了开始时间 → 禁用 早于 startTime 的月份
          const startTime = new Date(this.ruleForm.startTime);
          return time.getTime() < startTime.getTime();
        },
      },
      startTimePickerOptions: {
        disabledDate: (time) => {
          if (!this.ruleForm.endTime) return false;
          const end = new Date(this.ruleForm.endTime);
          return time.getTime() > end.getTime();
        },
      },
      rules: {
        schoolName: vxRule(true, "", ["blur", "change"], "请输入学校名称"),
        subjectName: vxRule(true, "", ["blur", "change"], "请输入专业名称"),
        startTime: vxRule(true, "", ["blur", "change"], "请选择在校开始时间"),
        endTime: vxRule(true, "", ["blur", "change"], "请选择在校结束时间"),
      }, // 表单验证
      // 学校检索名要用到的
      options: [],
      value: [],
      list: [],
      loading: false, // 学校加载状态
      states: [], //  学校数据列表
      ApplyForAJob: "", // 为1时说明是在添加新的求职意向
      index: "", // 点击编辑时获取值，知道编辑的是哪一个
    };
  },
  components: {},
  mounted() {},
  methods: {
    // 学校搜索 可模糊可输入
    querySearch(queryString, cb) {
      postFindUniversityByName({ data: queryString }).then((res) => {
        for (var i in res.data) {
          res.data[i].value = res.data[i].name;
        }
        this.restaurants = res.data;
        var restaurants = this.restaurants;
        var results = queryString
          ? restaurants.filter(this.createStateFilter(queryString))
          : restaurants;

        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 3000 * Math.random());
      });
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1
        );
      };
    },
    handleSelect(item) {
      console.log(item, "item", this.ruleForm.schoolName);
    },
    // 添加
    handelClickEDITOR() {
      this.xlCode = "0"; // 学历
      this.fullTime = "0"; //全日
      this.ruleForm = {
        schoolCode: "", // 学校code
        schoolName: "", // 学校名称
        xlCode: "0", //学历code
        xlName: "初中及以下", // 学历选择
        fullTime: "0", //是否全日制的选择
        subjectCode: "", // 专业code
        subjectName: "", //专业
        startTime: "", // 在校时间开
        endTime: "", // 在校时间结束
        certiNum: "", // 证书编号
      }; // v-mode
      this.IndividualEdit = "2";

      // 选择框数据
      this.ApplyForAJob = "1";
    },

    // 专业远程搜索后 获取所选的code
    pestChange(val) {
      // 选择后清空选项避免影响后续的搜索
      this.options = [];
      postFindSubjectByName({ data: val }).then((res) => {
        if (res.data && res.data[0]) {
          this.ruleForm.subjectCode = res.data[0].code;
        }
      });
    },
    // 专业名远程搜索
    async Profession(query) {
      // 远程搜索前调用接口，传入搜索的数据获取专业名称放入this.states
      // 调用 获取专业名称接口
      await postFindSubjectByName({ data: query }).then((res) => {
        this.states = res.data;
        this.list = this.states.map((item) => {
          return {
            value: `${item.name}`,
            label: `${item.name}`,
            id: `${item.code}`,
          };
        });
      });
      // 组件 自带远程搜索的函数
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },

    // 点击选择 学历
    handelLearn(item) {
      this.xlCode = item.id;
      this.ruleForm.xlCode = item.id;
      this.ruleForm.xlName = item.name;
    },
    // 点击选择 全日制
    handelFullTime(item) {
      this.fullTime = item.id;
      this.ruleForm.fullTime = item.id;
    },
    // 点击编辑单条数据
    handelClickSingle(item, index) {
      this.index = item.id; // 获取要编辑的数据位置
      let newArr1 = JSON.parse(JSON.stringify(item));
      this.xlCode = newArr1.xlCode; // 学历
      const isFullTime =
        newArr1.fullTime == "0" || newArr1.fullTime == "全日制";
      this.fullTime = isFullTime ? "0" : "1";
      newArr1.fullTime = this.fullTime;
      this.ruleForm = newArr1;
      this.IndividualEdit = 2;
      this.ApplyForAJob = ""; // 判断是编辑还是添加框 为空时是编辑 1为添加
    },
    // 点击清除
    handelDele() {
      this.$confirmWithScroll("是否删除本条信息?", "提示").then(() => {
        var data = {
          data: {
            userId: this.$store.getters.getUser.id,
            id: this.index,
          },
        };
        deleteUserEducationExp(data).then((res) => {
          if (res.code == 0) {
            this.IndividualEdit = 1;
            this.ApplyForAJob = "";
            this.index = "";
            this.$emit("handelSubmitEdit");
            this.$tool.PromptBox("success", "修改成功");
          }
        });
      }).catch(() => {});
    },
    // 取消编辑
    handelUnEdit() {
      this.$emit("handelUnEdit", 6);
      this.IndividualEdit = 1;
    },
    // 编辑提交
    handelSubmitEdit(formName) {
      // 表单校验
      //if (valid) 校验成功 调接口继续下一步
      //else 校验失败  return false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this.ruleForm, "console.log(this.ruleForm)");
          if (this.ApplyForAJob == "") {
            // this.ApplyForAJob == ""时为编辑在原来的数据上修改
            var data = {};
            this.ruleForm.id = this.index;
            this.ruleForm.userId = this.$store.getters.getUser.id;
            data.data = this.ruleForm;

            // 调用接口修改简历个人信息
            editUserEducationExp(data).then((res) => {
              if (res.code == 0) {
                this.IndividualEdit = 1;
                this.ApplyForAJob = "";
                this.index = "";
                this.$emit("handelSubmitEdit");
                // 成功
                this.$tool.PromptBox("success", "修改成功");
                // 修改成功后应是传参给父组件让父组件刷新简历信息，但暂时没有简历信息接口
              } else {
                // 失败
                // this.$tool.PromptBox("error", res.msg);
              }
            });
          } else {
            // 为添加，在原来的数据前新增一条

            var data = {};
            this.ruleForm.userId = this.$store.getters.getUser.id;
            data.data = this.ruleForm;

            // 调用接口修改简历个人信息
            addUserEducationExp(data).then((res) => {
              if (res.code == 0) {
                this.IndividualEdit = 1;
                this.ApplyForAJob = "";
                this.index = "";
                this.$emit("handelSubmitEdit");
                // 成功
                this.$tool.PromptBox("success", "修改成功");
                // 修改成功后应是传参给父组件让父组件刷新简历信息，但暂时没有简历信息接口
              } else {
                // 失败
                // this.$tool.PromptBox("error", res.msg);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-form-item {
  width: 100%;
  margin-bottom: 0px;
  height: 35px;
}
/deep/.el-date-editor {
  position: relative !important;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}
// input 框内的icon
/deep/.el-input__icon {
  font-size: 20px !important;
  // margin-top: -3px;
}
// 远程搜索框的宽
.el-autocomplete {
  width: 100%;
}
// 修改el组件库input框的样式
/deep/.el-input__inner {
  width: 100% !important;
  height: 35px;
  border: 1px solid #409eff ;
  //   border-radius: 5px;
  //   border-right: none;
}
// 修改el组件库文本框的最小高度
/deep/.el-textarea {
  min-height: 80px !important;
}
// 正常展示的大div
.normal {
  width: 100%;
  min-height: 25px;
  position: relative;
  border: 1px solid transparent;
}
// 编辑栏的大div
.editor {
  width: 100%;
  min-height: 25px;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
  position: relative;
}
// 添加icon样式
.Title-Add-box {
  display: flex;
  position: absolute;
  font-size: 12px;
  top: -45px;
  left: 120px;
}
.Title-Add {
  width: 18px;
  height: 18px;
  background-image: url("../../../../../../assets/imgs/tianjia@2x.svg");
  background-size: 100% 100%;
  margin: auto 0;
  margin-left: 30px;
  margin-right: 5px;
}

// 正常展示
.NormalDisplay {
  width: 100%;
  display: flex;
  flex-direction: column;
  // 无数据
  .None {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border: 1px dashed #409eff ;
    border-radius: 5px;
    font-size: 12px;
    color: #333333;
    font-weight: 400;
  }
  .normal-show:nth-child(1) {
    margin-top: 0px;
  }
  // 有数据正常展示
  .normal-show {
    width: 900px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
    font-weight: 400;
    overflow-wrap: break-word;
    margin-top: 20px;
    .top-threeRows:nth-child(1) {
      margin-top: 0px;
    }
    .top-threeRows {
      width: 100%;
      height: 25px;
      line-height: 25px;
      margin-top: 15px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #333333;
      font-weight: 400;
      display: flex;

      p {
        margin-right: 20px;
      }
      .CompanyName {
        font-size: 16px;
      }
      .icon {
        width: 18px;
        height: 18px;
        margin: auto 0;
        background-image: url("../../../../../../assets/imgs/bianji@3x.svg");
        background-size: 100% 100%;
      }
    }
  }
}
// 开始编辑
.StartEditing {
  flex: 1;
  margin: 30px 20px 20px 30px;
  display: flex;
  flex-direction: column;
  .EDITOR-top {
    width: 100%;
    margin-bottom: 20px;
    .EDITOR-required {
      width: 100%;
      min-height: 30px;
      display: flex;
      .required-title-p {
        min-width: 50px;
        text-align: right;
        p:nth-child(2) {
          height: 80px;
        }

        p {
          height: 35px;
          line-height: 35px;
          margin-bottom: 25px;
          font-size: 14px;
          color: #333333;
          font-weight: 400;
        }
      }
      .required-ipt {
        width: 350px;
        .input-place:nth-child(2) {
          height: 80px;
          width: 450px;
          display: flex;
          flex-wrap: wrap;
          align-content: space-around;
          //   border: 1px solid gold;
        }
        .input-place {
          width: 100%;
          height: 35px;
          margin-top: 25px;
          display: flex;
          position: relative;
          .to-p {
            width: 60px;
            text-align: center;
            font-size: 14px;
          }
          p {
            line-height: 35px;
          }
          .Select-All {
            width: 90px;
            height: 35px;
            font-family: PingFangSC-Medium;
            font-size: 12px;
            color: #409eff ;
            text-align: center;
            font-weight: 400;
            border-radius: 5px;
            border: 1px solid #409eff ;
            margin-right: 15px;
          }
          // 是否全日制 选择
          .Select-p {
            background: rgba(97, 144, 232, 0.27);
          }
          .notSelect-p {
            background: #ffffff;
          }
        }
        .input-place:nth-child(1) {
          margin-top: 0;
        }
      }
      .required-dele {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        div {
          width: 20px;
          height: 20px;
          background-image: url("../../../../../../assets/imgs/shanchu@3x.svg");
          background-size: 100% 100%;
        }
      }
    }
    .EDITOR-Description {
      width: 100%;
      min-height: 30px;
      p {
        flex: 1;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
        margin-bottom: 5px;
      }
    }
  }
  // 编辑栏 按钮样式
  .EDITOR-btm {
    width: 100%;
    height: 40px;
    // margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    .Cancel {
      box-sizing: border-box;
      border: 1px solid #999999;
      color: #333333;
      margin-right: 20px;
      cursor: pointer;
    }
    .verify {
      background: #409eff ;
      color: #ffffff;
      cursor: pointer;
    }
    p {
      border-radius: 5px;
      font-family: PingFangSC-Medium;
      width: 120px;
      height: 40px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      line-height: 40px;
    }
  }
}
</style>
